import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  width: "22",
  height: "22",
  "aria-hidden": "true",
  class: "open-or-close-trigger__icon"
}
const _hoisted_3 = ["xlink:href"]
const _hoisted_4 = { class: "open-or-close" }
const _hoisted_5 = { class: "open-or-close-heading-box" }
const _hoisted_6 = {
  key: 0,
  class: "open-or-close-title"
}
const _hoisted_7 = {
  width: "27",
  height: "27",
  "aria-hidden": "true"
}
const _hoisted_8 = ["xlink:href"]
const _hoisted_9 = {
  key: 0,
  class: "open-or-close-list"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["innerHTML"]

import OpenOrCloseSummary from './OpenOrCloseSummary.vue';
  import { computed, ref } from 'vue';
  import {
    useOpeningHours,
    formatTimeAmPm as formatTime,
    formatClosingMessage,
    isPastClosingTime,
    type OpeningHoursItem,
    type OpeningHoursOverride,
  } from '../../modules/utils/useOpeningHours';
  import { useOpenOrClosePanel } from '../utils/useOpenOrClosePanel';
  import { spriteUrl } from '../utils/spriteUrl';
  import { useDraggable } from '../utils/useDraggable';

  interface Props {
    heading?: string;
    openingMessage?: string;
    closingMessage?: string;
    openingHours?: OpeningHoursItem[];
    openingHoursOverride?: OpeningHoursOverride[];
    openingAnnouncement?: string;
    summaryOnly?: boolean;
    summaryLink?: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'OpenOrClose',
  props: {
    heading: { default: '' },
    openingMessage: { default: '' },
    closingMessage: { default: '' },
    openingHours: { default: () => [] },
    openingHoursOverride: { default: () => [] },
    openingAnnouncement: { default: '' },
    summaryOnly: { type: Boolean, default: false },
    summaryLink: { default: '' }
  },
  setup(__props: any) {

  const props = __props;

  const { displaySchedule, todayDisplay, nextOpenDisplay } = useOpeningHours(
    () => props.openingHours,
    () => props.openingHoursOverride,
  );

  const { isOpen, openPanel, close } = useOpenOrClosePanel();
  const { isDragging, dragStyle, startDrag } = useDraggable();
  const boxRef = ref<HTMLElement | null>(null);

  function onBoxMouseDown(e: MouseEvent) {
    if (boxRef.value) startDrag(e, boxRef.value);
  }

  const isCurrentlyClosed = computed(() =>
    !todayDisplay.value ||
    todayDisplay.value.isClosed ||
    isPastClosingTime(todayDisplay.value.closes)
  );

  const closedMessage = computed(() =>
    formatClosingMessage(todayDisplay.value?.message || props.closingMessage || 'Closed', nextOpenDisplay.value)
  );

return (_ctx: any,_cache: any) => {
  return (__props.summaryOnly)
    ? (_openBlock(), _createBlock(OpenOrCloseSummary, {
        key: 0,
        "summary-link": __props.summaryLink,
        "opening-message": __props.openingMessage,
        "closing-message": __props.closingMessage,
        "opening-hours": __props.openingHours,
        "opening-hours-override": __props.openingHoursOverride
      }, null, 8 /* PROPS */, ["summary-link", "opening-message", "closing-message", "opening-hours", "opening-hours-override"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("button", {
          "aria-label": "Open opening hours",
          title: "Opening hours",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openPanel) && _unref(openPanel)(...args))),
          class: "open-or-close-trigger cursor-pointer"
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_2, [
            _createElementVNode("use", {
              "xlink:href": _unref(spriteUrl)('clock-light-icon')
            }, null, 8 /* PROPS */, _hoisted_3)
          ]))
        ], 512 /* NEED_PATCH */), [
          [_vShow, !_unref(isOpen)]
        ]),
        _createVNode(_Transition, { name: "oc-fade" }, {
          default: _withCtx(() => [
            (_unref(isOpen))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(close) && _unref(close)(...args))),
                  class: "open-or-close-backdrop"
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", {
          ref_key: "boxRef",
          ref: boxRef,
          style: _normalizeStyle(_unref(dragStyle)),
          onMousedown: onBoxMouseDown,
          class: _normalizeClass(["open-or-close-box", { 
            'is-open': _unref(isOpen),
            'is-dragging': _unref(isDragging) 
          }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (__props.heading)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(__props.heading), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", {
                class: _normalizeClass(["open-or-close-current_status", { 'is-closed': isCurrentlyClosed.value }])
              }, [
                (isCurrentlyClosed.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(closedMessage.value) + " ", 1 /* TEXT */),
                      (_unref(nextOpenDisplay)?.opens)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(formatTime)(_unref(nextOpenDisplay).opens)), 1 /* TEXT */)
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Opens: " + _toDisplayString(_unref(formatTime)(_unref(todayDisplay)?.opens)), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
              ], 2 /* CLASS */),
              _createElementVNode("button", {
                "aria-label": "Close opening hours",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(close) && _unref(close)(...args))),
                class: "open-or-close-close-btn cursor-pointer",
                title: "Close opening hours"
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                  _createElementVNode("use", {
                    "xlink:href": _unref(spriteUrl)('icon-close')
                  }, null, 8 /* PROPS */, _hoisted_8)
                ]))
              ])
            ]),
            (_unref(displaySchedule).length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displaySchedule), (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.displayName,
                      class: _normalizeClass([
                'open-or-close-item',
                { 'is-active': item.isToday }
              ])
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(item.displayName) + ": ", 1 /* TEXT */),
                      _createElementVNode("div", null, [
                        (!item.isClosed)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (item.label)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(item.label) + " - ", 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                              _createTextVNode(" " + _toDisplayString(_unref(formatTime)(item.opens)) + " - " + _toDisplayString(_unref(formatTime)(item.closes)), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.label || 'Closed'), 1 /* TEXT */))
                      ])
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            (__props.openingAnnouncement)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  innerHTML: __props.openingAnnouncement,
                  class: "open-or-close-holidays_message"
                }, null, 8 /* PROPS */, _hoisted_11))
              : _createCommentVNode("v-if", true)
          ])
        ], 38 /* CLASS, STYLE, NEED_HYDRATION */)
      ]))
}
}

})